<template>
  <modal
    :name="name"
    class="modal"
    :class="'is--mobile-' + mobileType"
    :width="width"
    height="auto"
    :adaptive="true"
    :clickToClose="frame"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="modal__top" v-if="frame">
      <div class="modal__top__title">
        <i v-if="icon" :class="icon" />
        {{ title }}
      </div>
      <div class="modal__top__close">
        <i class="is--normal-icon ri-close-line" @click="close"></i>
        <i class="is--full-icon ri-arrow-left-line" @click="close"></i>
      </div>
    </div>
    <div class="modal__wrap">
      <div
        class="modal__body"
        :class="{'is--footer': footer && footer.items && footer.items.length}"
      >
        <slot />
      </div>
      <div
        class="modal__footer"
        :class="{'is--top-line': footer.lineTop, 'without-frame': !frame}"
        v-if="footer && footer.items && footer.items.length">
        <button
          v-for="footerItem in footer.items"
          :key="footerItem.action"
          :class="footerItem.type"
          @click="action(footerItem)"
        >{{ footerItem.title | translate }}</button>
      </div>
    </div>
    <div class="modal__bubble-close" v-if="frame">
      <span @click="close">
        <i class="ri-close-line"></i>
      </span>
    </div>
  </modal>
</template>

<script>
export default {
  props: ['name', 'icon', 'title', 'width', 'footer', 'mobileType', 'frame'],
  methods: {
    close() {
      this.$modal.hide(this.name)
    },
    action(item) {
      this.$emit(item.action);

      if (item.close)
        this.close();
    },
    beforeOpen() {
      this.$emit('beforeOpen')
    },
    closed() {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss">

  .vm--modal {
    border-radius: 13px !important;
    max-height: 90vh;
  }

  .vm--container {
    z-index: 99999999;
  }

  .modal {
    color: var(--label-primary);
    &__wrap {
      max-height: calc(90vh - 64px);
      overflow: auto;
    }
    &__top {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom: 1px solid var(--grey-04);
      height: 64px;
      &__title {
        font-size: 22px;
        font-weight: 600;
        line-height: 27px;
        font-feature-settings: 'zero' on;
        display: flex;
        align-items: center;
        padding: 20px 0 16px 0;
        i {
          vertical-align: middle;
          margin-right: 8px;
          font-size: 24px;
          font-weight: normal;
        }
      }
      &__close {
        position: absolute;
        top: 20px;
        right: 24px;
        i {
          vertical-align: middle;
          font-size: 24px;
          cursor: pointer;
          &.is--full-icon {
            display: none;
          }
        }
      }
    }
    &__footer {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px 0;
      &.without-frame {
        padding: 16px 0;
      }
      button {
        width: auto;
        padding-left: 20px;
        padding-right: 20px;
        margin-left: 12px;
        margin-right: 12px;
      }
      &.is--top-line {
        border-top: 1px solid var(--grey-04);
      }
    }
    &__bubble-close {
      display: none;
      position: absolute;
      top: calc(100% + 16px);
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: center;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 100%;
        background: var(--light-02);
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.32);
        color: var(--label-secondary);
        font-size: 24px;
      }
    }
  }

  @media (max-width: 425px) {
    .is--mobile {
      &-full {
        .vm--modal {
          height: 100% !important;
          border-radius: 0 !important;
          max-height: 100vh;
        }
        .modal {
          &__wrap {
            max-height: calc(100vh - 48px);
          }
          &__top {
            height: 48px;
            &__title {
              i {
                display: none;
              }
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              padding: 12px 0;
            }
            &__close {
              top: 12px;
              right: auto;
              left: 12px;
              i {
                &.is--full-icon {
                  display: block;
                  color: var(--label-secondary);
                }
                &.is--normal-icon {
                  display: none;
                }
              }
            }
          }
          &__body {
            overflow: auto;
            height: calc(100% - 49px);
            &.is--footer {
              height: 100%;
            }
          }
          &__footer {
            padding: 8px;
            button.secondary {
              display: none;
            }
            button.primary {
              margin: 0;
              width: 100%;
            }
          }
        }
      }
      &-bubble,
      &-bubble-flat {
        .vm--modal {
          overflow: visible;
          max-height: 65vh;
        }
        .modal {
          &__wrap {
            max-height: 65vh;
          }
          &__top {
            display: none;
          }
          &__bubble-close {
            display: flex;
          }
        }
      }
      &-bubble {
        .vm--modal {
          width: calc(100% - 16px) !important;
          margin: 0 auto;
        }
      }
      &-bubble-flat {
        .vm--modal {
          box-shadow: none;
          border-radius: 0 !important;
        }
      }
    }
  }
</style>
